import gql from 'graphql-tag';

export const HierarchyViewsCreate = gql`
  mutation hierarchyViewsCreate($input: HierarchyViewsCreateInput!) {
    hierarchyViewsCreate(input: $input) {
      success
    }
  }
`;

export const HierarchyAllPhotosAccessViewCreate = gql`
  mutation hierarchyAllPhotosAccessViewCreate(
    $input: HierarchyAllPhotosAccessViewCreateInput!
  ) {
    hierarchyAllPhotosAccessViewCreate(input: $input) {
      success
    }
  }
`;

export const AlbumMembershipGroupUnjoin = gql`
  mutation albumMembershipGroupUnjoin(
    $input: AlbumMembershipGroupUnjoinInput!
  ) {
    albumMembershipGroupUnjoin(input: $input) {
      success
    }
  }
`;

export const AccountHierarchySettingsUpdate = gql`
  mutation AccountHierarchySettingsUpdate(
    $input: AccountHierarchySettingsUpdateInput!
  ) {
    accountHierarchySettingsUpdate(input: $input) {
      account_hierarchy_settings {
        id
        notifications_enabled

        album {
          id
          account_hierarchy_settings {
            id
            notifications_enabled
          }
        }

        album_folder {
          id
          account_hierarchy_settings {
            id
            notifications_enabled
          }
        }
      }
    }
  }
`;
